import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
//添加以下代码
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

 
export default new Router({
    routes: [
        {
            path: "/",
            name: "index",
            component: () =>
            import ("./page/index.vue")
        },
        {
            path: "/panoPage",
            name: "panoPage",
            component: () =>
            import ("./page/panoPage.vue")
        },
        
    ]
});